const badge = (status) => {
  const map = {
    paid: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    initiated: "bg-zinc-500/15 text-zinc-400 border-zinc-500/30",
    unpaid: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    expired: "bg-red-500/15 text-red-400 border-red-500/30",
  };
  return map[status] || map.initiated;
};

export const OrdersTable = ({ orders, onResend, onCopyLink }) => {
  if (!orders.length) {
    return (
      <div className="mt-8 rounded-2xl border border-white/10 bg-[#0b0d10] p-12 text-center text-zinc-500" data-testid="orders-empty-state">
        No orders yet. Once someone starts a checkout, it will show up here.
      </div>
    );
  }

  return (
    <div className="mt-8 overflow-x-auto rounded-2xl border border-white/10 bg-[#0b0d10]" data-testid="orders-table">
      <table className="w-full text-left text-sm">
        <thead>
          <tr className="border-b border-white/10 text-xs uppercase tracking-widest text-zinc-500">
            <th className="px-5 py-4">Date</th>
            <th className="px-5 py-4">Email</th>
            <th className="px-5 py-4">Product</th>
            <th className="px-5 py-4">Amount</th>
            <th className="px-5 py-4">Payment</th>
            <th className="px-5 py-4">PDF sent</th>
            <th className="px-5 py-4">Recovery</th>
            <th className="px-5 py-4">Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={o.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.03]" data-testid={`order-row-${o.id}`}>
              <td className="whitespace-nowrap px-5 py-4 text-zinc-400">
                {new Date(o.created_at).toLocaleString("en-AU", { dateStyle: "medium", timeStyle: "short" })}
              </td>
              <td className="px-5 py-4 text-white">{o.email}</td>
              <td className="px-5 py-4 text-zinc-300">{o.package_name}</td>
              <td className="whitespace-nowrap px-5 py-4 font-semibold text-white">A${o.amount}</td>
              <td className="px-5 py-4">
                <span className={`rounded-full border px-3 py-1 text-xs font-medium ${badge(o.payment_status)}`}>
                  {o.payment_status}
                </span>
              </td>
              <td className="px-5 py-4 text-zinc-400">
                {o.delivery_sent ? "✓ Yes" : o.last_delivery_error ? (
                  <span className="text-red-400" title={o.last_delivery_error}>✗ Failed</span>
                ) : "—"}
              </td>
              <td className="px-5 py-4 text-zinc-400">{o.recovery_sent ? "✓ Sent" : "—"}</td>
              <td className="px-5 py-4">
                <div className="flex gap-2">
                  <button
                    onClick={() => onResend(o)}
                    disabled={o.payment_status !== "paid"}
                    className="whitespace-nowrap rounded-full border border-white/15 bg-white/5 hover:bg-white/10 disabled:opacity-30 disabled:cursor-not-allowed px-3 py-1.5 text-xs text-white transition-colors"
                    data-testid={`resend-button-${o.session_id}`}
                  >
                    Resend email
                  </button>
                  <button
                    onClick={() => onCopyLink(o)}
                    disabled={o.payment_status !== "paid"}
                    className="whitespace-nowrap rounded-full border border-[#2f7fff]/40 bg-[#2f7fff]/10 hover:bg-[#2f7fff]/20 disabled:opacity-30 disabled:cursor-not-allowed px-3 py-1.5 text-xs text-white transition-colors"
                    data-testid={`copy-link-button-${o.session_id}`}
                  >
                    Copy download link
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
